import { render, staticRenderFns } from "./iconFiletypes.vue?vue&type=template&id=5827189c"
import script from "./iconFiletypes.vue?vue&type=script&lang=js"
export * from "./iconFiletypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports